import { apiFetch } from './api';

const IMAGEKIT_PUBLIC_KEY = 'public_LZK3FEVCE82GjoaNXFUpFEY/P74=';
const IMAGEKIT_UPLOAD_URL = 'https://upload.imagekit.io/api/v1/files/upload';

export const uploadToImageKit = async (file, token) => {
  const authRes = await apiFetch('/api/admin/imagekit/auth', {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!authRes.ok) throw new Error('Failed to get ImageKit auth');
  const authData = await authRes.json();

  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileName', file.name);
  formData.append('publicKey', IMAGEKIT_PUBLIC_KEY);
  formData.append('signature', authData.signature);
  formData.append('expire', authData.expire);
  formData.append('token', authData.token);

  const uploadRes = await fetch(IMAGEKIT_UPLOAD_URL, { method: 'POST', body: formData });
  if (!uploadRes.ok) throw new Error('Image upload failed');
  const { url, fileId } = await uploadRes.json();
  return { url, fileId };
};
